import { UserPermission } from '@globaleris/ui.library'
import { CardProps } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StandardCard } from '../../../../components/shared/standardCard/standardCard'
import { GlobalObjectionTableModel } from '../../settlements.models'
import { GlobalObjectionsDataTable } from '../globalObjectionsDataTable/globalObjectionsDataTable'

interface GlobalObjectionsCardProps extends CardProps {
  title?: string
  hideTitle?: boolean
  isLoading?: boolean
  show?: boolean
  objectionsData?: GlobalObjectionTableModel[]
  hasEditPermission?: boolean
  tableUserPermissions?: UserPermission[]
  onTerminateObjection?: (row: GlobalObjectionTableModel) => Promise<void>
}

export const GlobalObjectionsCard: React.FC<GlobalObjectionsCardProps> = ({
  isLoading = false,
  show = true,
  objectionsData,
  hasEditPermission = false,
  tableUserPermissions,
  onTerminateObjection,
  title,
  hideTitle = false,
  ...props
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'settlements'])

  const noData = objectionsData && objectionsData.length === 0

  return show ? (
    <StandardCard
      isLoading={isLoading}
      noTransition={false}
      showEmptyContent={noData}
      emptyCaption={t('settlements:components.globalObjectionsCard.emptyCaption')}
      {...props}
    >
      <GlobalObjectionsDataTable
        title={
          !hideTitle ? (title ?? t('settlements:components.globalObjectionsCard.title')) : undefined
        }
        objectionsData={objectionsData}
        hasEditPermission={hasEditPermission}
        tableUserPermissions={tableUserPermissions}
        onTerminateObjection={onTerminateObjection}
      />
    </StandardCard>
  ) : (
    <></>
  )
}
